import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";



interface UserData {
  name: string;
  email: string;
  id: string;
  role: string;
}

const NavbarAuth = () => {
  const [currentUser, setCurrentUser] = useState<UserData | null>(null);
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  // Charger les items et l'utilisateur au montage du composant
  useEffect(() => {
    // Récupérer les données utilisateur depuis le localStorage
    const userData = localStorage.getItem('userData');
    if (userData) {
      setCurrentUser(JSON.parse(userData));
    }
  }, []);

  return (
    <nav className="bg-gradient-to-r from-gray-800 to-gray-900 text-white p-4 fixed w-full top-0 shadow-lg z-50">
      <div className="container mx-auto flex justify-between items-center">
        {/* Logo */}
        <Link to="/employee" className="text-3xl font-extrabold text-yellow-500 cursor-pointer hover:text-yellow-600 transition duration-300">
          GMCL
        </Link>

        {/* Bouton Burger */}
        <button
          className="text-yellow-500 md:hidden focus:outline-none"
          onClick={() => setIsOpen(!isOpen)}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}></path>
          </svg>
        </button>

        {/* Menu de Navigation */}
        <ul className={`md:flex md:space-x-8 md:items-center absolute md:static top-16 right-0 bg-gray-900 md:bg-transparent w-full md:w-auto ${isOpen ? "block" : "hidden"} space-y-4 md:space-y-0 p-4 md:p-0`}>
          <li>
            <Link
              to="/employee"
              className={`block md:inline hover:text-yellow-400 transition duration-300 ${location.pathname === "/employee" ? "text-yellow-500 border-b-2 border-yellow-500" : ""}`}
              onClick={() => setIsOpen(false)}
            >
              Profiles
            </Link>
          </li>
          {currentUser?.role === 'manager' && (

            <><li>
              <Link
                to="/stock"
                className={`block md:inline hover:text-yellow-400 transition duration-300 ${location.pathname === "/stock" ? "text-yellow-500 border-b-2 border-yellow-500" : ""}`}
                onClick={() => setIsOpen(false)}
              >
                Stock
              </Link>
            </li><li>
                <Link
                  to="/estimation"
                  className={`block md:inline hover:text-yellow-400 transition duration-300 ${location.pathname === "/estimation" ? "text-yellow-500 border-b-2 border-yellow-500" : ""}`}
                  onClick={() => setIsOpen(false)}
                >
                  Estimation
                </Link>
              </li><li>
                <Link
                  to="/rendez-vous"
                  className={`block md:inline hover:text-yellow-400 transition duration-300 ${location.pathname === "/rendez-vous" ? "text-yellow-500 border-b-2 border-yellow-500" : ""}`}
                  onClick={() => setIsOpen(false)}
                >
                  Rendez-vous
                </Link>
              </li></>



          )}

          <li>
            <Link
              to="/Time-Card"
              className={`block md:inline hover:text-yellow-400 transition duration-300 ${location.pathname === "/Time-Card" ? "text-yellow-500 border-b-2 border-yellow-500" : ""}`}
              onClick={() => setIsOpen(false)}
            >
              Feuille de temps
            </Link>
          </li>
          <li>
            <button
              onClick={() => {
                localStorage.removeItem('userData');
                window.location.href = '/';
              }}
              className="block md:inline bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded transition duration-300"
            >
              Déconnexion
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default NavbarAuth;